import { poolDetailsMap } from '../common/maps.js';
export class AlphaFiReceipt {
    alphafiReceipt;
    blockchain;
    constructor(alphafiReceipt, blockchain) {
        this.alphafiReceipt = alphafiReceipt;
        this.blockchain = blockchain;
    }
    async getTotalShares(poolId) {
        let entry = this.alphafiReceipt.position_pool_map.find(item => item.value.pool_id === poolId);
        if (!entry) {
            console.error("no position for pool id found");
            return "0";
        }
        if (poolDetailsMap[poolId].poolName === "ALPHA") {
            let position = await this.blockchain.getAlphaPosition(entry.key);
            return position.xtokens;
        }
        return "0";
    }
}
//# sourceMappingURL=alphafiReceipt.js.map